import { isNull } from 'lodash';
import {
	MedicalDeclarationQuestionsResponse,
	QuestionTypeSchema,
	QuestionTypes,
} from '@shory-health-individual/customer-api';
import { PlanCategory } from '../../../../common';
import { JourneyDetails } from '../../../../server';
import { IDeclarationQuestionsForm } from '../types';

const getAnswer = (q: QuestionTypeSchema) => {
	if (q.dataTypeId === QuestionTypes.CheckBox) {
		const savedAnswer = q.answers.find((a) => a.id === q.savedAnswerId)?.answerText;

		return savedAnswer === 'true';
	}

	if (q.dataTypeId === QuestionTypes.DatePicker || q.dataTypeId === QuestionTypes.YearPicker) {
		return q.savedAnswer ?? '';
	}

	return q?.savedAnswerId ?? undefined;
};

export const getInitialValues = (
	journeyDetails: JourneyDetails,
	declarationQuestions?: MedicalDeclarationQuestionsResponse
) =>
	declarationQuestions?.reduce<IDeclarationQuestionsForm>((acc, m) => {
		const isMedicalConditionDeclared =
			journeyDetails.quotePlanCategoryId === PlanCategory.Basic
				? 0
				: isNull(m.isMedicalConditionDeclared)
				? undefined
				: m.isMedicalConditionDeclared
				? 1
				: 0;
		const questions =
			m?.questions?.reduce(
				(acc, q) => ({
					...acc,
					[`q-${q.id}`]: {
						answer: getAnswer(q),
						dataTypeId: q.dataTypeId,
					},
				}),
				{}
			) ?? {};

		return {
			...acc,
			[m.memberId]: {
				questions,
				isMedicalConditionDeclared: isMedicalConditionDeclared,
				height: m.height ? m.height : undefined,
				weight: m.weight ? m.weight : undefined,
			},
		};
	}, {}) ?? {};
